// extracted by mini-css-extract-plugin
export default {"modal":"modalbox-search-filter_modal__QQ2SG","scrollbar":"modalbox-search-filter_scrollbar__ieL3q"};